import { render } from "./MyOrdersBigud.vue?vue&type=template&id=9414fa42&scoped=true"
import script from "./MyOrdersBigud.vue?vue&type=script&lang=js"
export * from "./MyOrdersBigud.vue?vue&type=script&lang=js"

import "./MyOrdersBigud.vue?vue&type=style&index=0&id=9414fa42&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9414fa42"]])

export default __exports__